module.exports = __webpack_public_path__ + "img/operateur-qualite.67f24530.png";